import { render, staticRenderFns } from "./platfromlist.vue?vue&type=template&id=05259b44&scoped=true&"
import script from "./platfromlist.vue?vue&type=script&lang=js&"
export * from "./platfromlist.vue?vue&type=script&lang=js&"
import style0 from "./platfromlist.vue?vue&type=style&index=0&id=05259b44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05259b44",
  null
  
)

export default component.exports